/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Form, Modal, InputNumber, Space, Typography, Row, Col, Checkbox, message } from 'antd';
import emiter, { _EVENTS } from '../../../../events';
import { ExclamationCircleTwoTone } from '@ant-design/icons';
import { useCarModelPrice } from '../../../../hooks/product-price/car-model-price';
const { Text } = Typography;

interface PropsType {
	enums?: any;
	detail?: any;
}
const dayList = [1, 2, 3, 4, 5, 6, 7];

const WeekendPrice: React.FC<PropsType> = props => {
	const { detail, enums } = props;
	const [form] = Form.useForm();

	const { tableActionEdit, update } = useCarModelPrice();

	const [showModal, setShowModal] = useState(false);
	const [title, setTitle] = useState('');

	const mainFormFields = {
		zhouzhongjiage: {
			name: 'weekPrice',
			label: '周中',
			required: true,
			message: '请输入价格',
			placeholder: '请输入',
		},
		zhouzhongriqi: {
			name: 'weekCheckbox',
			label: '',
			required: true,
			message: '请选择',
		},
		zhoumojiage: {
			name: 'weekendPrice',
			label: '周末',
			required: true,
			message: '请输入价格',
			placeholder: '请输入',
		},
		zhoumoriqi: {
			name: 'weekendCheckbox',
			label: '',
			required: true,
			message: '请选择',
		},
	};

	// 更改价格显示
	const chengePriceFormat = (price: any) => {
		if (!price) return price;
		if (!isNaN(Number(price))) {
			price = price / 100;
		}
		return price;
	};

	const openModal = (data: any) => {
		if (detail && detail.price_detail) {
			const weekday = detail.price_detail.weekday || {};
			const weekend = detail.price_detail.weekend || {};
			if (weekday && weekday.price) {
				form.setFieldsValue({
					weekPrice: chengePriceFormat(weekday.price),
					weekendPrice: chengePriceFormat(weekend.price),
				});
			}
		}
		setTitle(data.title);
		setShowModal(true);
	};

	// 关闭弹窗
	const closeModal = () => {
		form.resetFields();
		setShowModal(false);
	};

	// 数组赋值
	const getValue = (value: any) => {
		const finalValue: number[] = [];
		dayList.forEach((item: any) => {
			if (!value.includes(item)) {
				finalValue.push(item);
			}
		});
		return finalValue;
	};

	// 周中复选框改变
	const changeWeek = (value: any) => {
		if (!value || (value && !value.length)) {
			form.setFieldsValue({ weekendCheckbox: dayList });
			return;
		}
		const finalValue = getValue(value);
		form.setFieldsValue({ weekendCheckbox: finalValue });
	};

	// 周末复选框改变
	const changeWeekend = (value: any) => {
		if (!value || (value && !value.length)) {
			form.setFieldsValue({ weekCheckbox: dayList });
			return;
		}
		const finalValue = getValue(value);
		form.setFieldsValue({ weekCheckbox: finalValue });
	};

	const formatPrice = (price: any) => {
		if (!price) return price;
		if (!isNaN(Number(price))) {
			price = price * 100;
		}
		return price;
	};

	// 修改价格
	const updatePrice = () => {
		form.validateFields().then(async (fieldsValue: any) => {
			const weekday = {
				day: fieldsValue.weekCheckbox,
				price: formatPrice(fieldsValue.weekPrice),
			};
			const weekend = {
				day: fieldsValue.weekendCheckbox,
				price: formatPrice(fieldsValue.weekendPrice),
			};
			const params = {
				...detail,
			};
			params.price_detail.weekday = weekday;
			params.price_detail.weekend = weekend;
			const result: any = await update(params);
			if (result.errno === 0) {
				message.success('操作成功');
				closeModal();
				tableActionEdit(detail);
			}
		});
	};

	const validatePrice = (_: any, value: any) => {
		if (!value) {
			return Promise.reject(new Error('请输入价格'));
		}
		if (value > 5000 || value < 1) {
			return Promise.reject(new Error('请输入1-5000的正整数'));
		}
		return Promise.resolve();
	};

	useEffect(() => {
		emiter.on(_EVENTS.PRODUCT_PRICE.CAR_MODEL_PRICE.WEEKEND_PRICE, openModal);
		return () => {
			emiter.removeAllListeners(_EVENTS.PRODUCT_PRICE.CAR_MODEL_PRICE.WEEKEND_PRICE)
		}
	}, []);

	return (
		<Modal
			title={
				<Space direction="vertical">
					<Text strong>周末周中定价</Text>
					<Text type="secondary">{title}</Text>
				</Space>
			}
			open={showModal}
			onCancel={closeModal}
			onOk={updatePrice}
			width={900}
			centered
		>
			<Form form={form}>
				<Row gutter={24}>
					<Col span={10}>
						<Form.Item
							required
							label={<span style={{ color: 'orange' }}>{mainFormFields.zhouzhongjiage.label}</span>}
							name={mainFormFields.zhouzhongjiage.name}
							rules={[
								{
									validator: validatePrice,
								},
							]}
						>
							<InputNumber
								placeholder={mainFormFields.zhouzhongjiage.placeholder}
								controls={false}
								addonAfter={<div>元/天</div>}
								precision={0}
							/>
						</Form.Item>
					</Col>
					<Col span={14}>
						<Form.Item
							label={mainFormFields.zhouzhongriqi.label}
							name={mainFormFields.zhouzhongriqi.name}
							rules={[
								{
									required: mainFormFields.zhouzhongriqi.required,
									message: mainFormFields.zhouzhongriqi.message,
								},
							]}
							initialValue={[1, 2, 3, 4]}
						>
							<Checkbox.Group onChange={changeWeek}>
								{enums?.f_weekend_enum &&
									enums?.f_weekend_enum.map((item: any) => (
										<Checkbox value={item.key} key={item.key}>
											{item.value}
										</Checkbox>
									))}
							</Checkbox.Group>
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={24}>
					<Col span={10}>
						<Form.Item
							required
							label={<span style={{ color: 'orange' }}>{mainFormFields.zhoumojiage.label}</span>}
							name={mainFormFields.zhoumojiage.name}
							rules={[
								{
									validator: validatePrice,
								},
							]}
						>
							<InputNumber
								controls={false}
								addonAfter={<div>元/天</div>}
								precision={0}
								placeholder={mainFormFields.zhoumojiage.placeholder}
							/>
						</Form.Item>
					</Col>
					<Col span={14}>
						<Form.Item
							label={mainFormFields.zhoumoriqi.label}
							name={mainFormFields.zhoumoriqi.name}
							rules={[
								{
									required: mainFormFields.zhoumoriqi.required,
									message: mainFormFields.zhoumoriqi.message,
								},
							]}
							initialValue={[5, 6, 7]}
						>
							<Checkbox.Group onChange={changeWeekend}>
								{enums?.f_weekend_enum &&
									enums?.f_weekend_enum.map((item: any) => (
										<Checkbox value={item.key} key={item.key}>
											{item.value}
										</Checkbox>
									))}
							</Checkbox.Group>
						</Form.Item>
					</Col>
				</Row>
			</Form>
			<Space align="baseline">
				<ExclamationCircleTwoTone twoToneColor="#f82f1e" />
				提交后，立即生效
			</Space>
			<div>
				手动修改过的价格 及 节假日区间价格不会被覆盖，如需调整，请使用“节假日区间定价”或在“价格日历手动调整”
			</div>
		</Modal>
	);
};

export default WeekendPrice;
